module.exports = __webpack_public_path__ + "static/media/logo-emerald2.ea294bfb.svg";